<div
  class="tw-flex tw-h-screen tw-w-screen tw-flex-col tw-bg-night tw-p-3 tw-text-center tw-text-white"
>
  <!-- items-center centres the card vertically in whatever space the footer
       leaves; justify-center centres it horizontally. -->
  <div class="tw-flex tw-flex-grow tw-items-center tw-justify-center">
    <router-outlet></router-outlet>
  </div>
  <!-- Support above the copyright, both small and muted so the footer sits back
       from the card. The design specifies night-3 (#7d7a80), which is 3.61:1 on
       night and fails WCAG AA for text this size; night-4 is 6.38:1 and still
       reads as muted, so it is used instead. -->
  <footer class="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-py-2">
    <a
      href="mailto:support@humanmademachine.com"
      class="tw-text-xs tw-text-night-4 tw-underline hover:tw-text-white"
    >
      Support
    </a>
    <p class="tw-m-0 tw-text-xs tw-text-night-4">
      &copy;{{ year }} Human Made Machine
    </p>
  </footer>
</div>
